export default __webpack_public_path__ + "static/media/diamond.779320ad.svg";